// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: true,
    refineByStyle: 'style2',
    filterTreeMobileStyle: 'style1',
    paginationTypeAdvanced: true,
    activeLoadPreviousPage: true,
    enableKeepScrollbackPosition: true, // Scroll to the previous position after going back from Product page
    keepScrollbackPositionType: 'sessionStorage', // Where to save the scrollback position data: 'sessionStorage' or 'history'
  },
};

var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;
var numberQuickViewModalLoaded = 0;
var boost_promotion = typeof promotion_blocks !== 'undefined' ? promotion_blocks : [];

(function() {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  /************************** BUILD PRODUCT LIST **************************/

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function(data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;


    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices

    var highlight = false;
    var on_new = false;
    if (data.tags) {
      if (data.tags.indexOf('highlight') > -1) {
        highlight = true;
      }

      if (data.tags.indexOf('New') > -1 || data.tags.indexOf('new') > -1 || data.tags.indexOf('News') > -1 || data.tags.indexOf('news') > -1) {
        on_new = true;
      }
    }

    // Get Template
    var itemHtml = '';

    // Start Boost #143482
     if(boost_promotion.length > 0 && Globals.queryParams['page'] == 1){
      for(var i = 0; i < boost_promotion.length; i++){
        if(boost_promotion[i].position - 1 == index && boost_promotion[i].link != null && boost_promotion[i].image != null){
          itemHtml += '<div class="grid__item promotion_block grid-product product small--one-half '+ boost_promotion[i].width +' aos-init aos-animate mb-30">';
          itemHtml += '<a href="'+ boost_promotion[i].link +'">';
          itemHtml += '<div class="grid-product__content" style="background:url('+ boost_promotion[i].image +'); background-repeat: no-repeat; background-size: cover; background-position: center; display:flex; height:100%; align-items: ;"></div>';
          itemHtml += '</a>';
          itemHtml += '</div>';
        }
      }
    }
    // End Boost #143482

    if (index == 0 &&
        	Globals.queryParams.page == 1 &&
        	!Utils.checkExistFilterOptionParam() &&
        	!Utils.isSearchPage() &&
        	boostPFSThemeConfig.custom.hasOwnProperty('banner_link') &&
        	boostPFSThemeConfig.custom.banner_link != '') {
      itemHtml += '<div class="grid__item featuredImage ' + (highlight ? "medium-up--one-half small--one-half" : "{{grid_item_width}}") + ' mb-30" data-aos="row-of-{{products_per_row}}">';
      itemHtml += '<a href="' + (boostPFSThemeConfig.custom.banner_link != '' ? boostPFSThemeConfig.custom.banner_link : '{{itemUrl}}') + '">';
      itemHtml += '<div class="grid-product__content" style="background:url(' + boostPFSThemeConfig.custom.banner_image + '); ' +
      					'background-repeat: no-repeat; background-size: cover; background-position: center; ' +
      					'display:flex; height:100%; align-items: flex-start;">';
      if (boostPFSThemeConfig.custom.banner_link == '' || boostPFSThemeConfig.custom.banner_image == '') {
        itemHtml += '<div class="grid-product__meta {{ps_hor}} w-100">';
    	itemHtml += '</div>';
      }
	  itemHtml += '</div>';
      itemHtml += '</a>';
      itemHtml += '</div>';
    }

    if (highlight) {
      itemHtml += boostPFSTemplate.productHighLightItemHtml
    } else {
      itemHtml += boostPFSTemplate.productGridItemHtml;
    }

    itemHtml = itemHtml.replace(/{{grid_item_width}}/g, boostPFSConfig.custom.grid_item_width);
    itemHtml = itemHtml.replace(/{{products_per_row}}/g, boostPFSConfig.custom.products_per_row);

    // Add Thumbnail
    var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : '';
    var paddingBottom = images.length > 0 ? 100 / aspectRatio : '100';
    var thumb = images.length > 0 ? images[0] : boostPFSConfig.general.no_image_url;
    var productGridImageFillClass = '';
    if(boostPFSConfig.custom.hasOwnProperty('product_grid_image_fill') && boostPFSConfig.custom.product_grid_image_fill){
      productGridImageFillClass = 'grid__image-contain';
    }
    var itemImagesHtml = '';
    if (boostPFSConfig.custom.product_grid_image_size == 'natural') {
      itemImagesHtml += '<div data-link= "' + Utils.buildProductItemUrl(data) + '" data-main="' + Utils.getFeaturedImage(images, '1080x') + '" class="image-wrap" style="height: 0; padding-bottom: ' + paddingBottom + '%;">';
      itemImagesHtml += '<img ' +
                  'class="grid-product__image lazyload" ' +
                  'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
                  'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                  'data-aspectratio="' + aspectRatio + '" ' +
                  'data-sizes="auto" ' +
                  'alt="{{itemTitle}}">';
      itemImagesHtml += '<noscript>' +
                '<img class="grid-product__image lazyloaded" ' +
                'src="' + Utils.getFeaturedImage(images, '400x') + '" ' +
                'alt="{{itemTitle}">' +
              '</noscript>';
      itemImagesHtml += '</div>';

    } else {
      itemImagesHtml += '<div class="grid__image-ratio grid__image-ratio--' + boostPFSConfig.custom.product_grid_image_size + '" >';
      itemImagesHtml += '<img ' +
        'class="lazyload ' + productGridImageFillClass + '" ' +
        'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
        'data-widths="[360, 540, 720, 900, 1080]" ' +
        'data-aspectratio="' + aspectRatio + '" ' +
        'data-sizes="auto" ' +
        'alt="{{itemTitle}}">';
      itemImagesHtml += '</div>';
    }

    if (!soldOut) {
      if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
        itemImagesHtml += '<div class="grid-product__secondary-image small--hide">';
        itemImagesHtml += '<img class="lazyload"' +
          'data-src="' + Utils.optimizeImage(images[1].src, '{width}x') + '"' +
          'data-widths="[360, 540, 720, 900, 1080]"' +
          'data-aspectratio="' + aspectRatio + '"' +
          'data-sizes="auto"' +
          'alt="{{itemTitle}}">';
        itemImagesHtml += '</div>';
      }
    }

    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Price
    var itemSaleClass = '';
    if (onSale) {
      itemSaleClass = 'product_on_sale';
    }
    itemHtml = itemHtml.replace(/{{itemSaleClass}}/g, itemSaleClass);

    var itemPriceHtml = '';
    if (onSale) {
      itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
      itemPriceHtml += '<span class="grid-product__price--original">' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
      itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
    }
    if (priceVaries) {
      itemPriceHtml += boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, (Utils.formatMoney(data.price_min)  ));
    } else {
      if (onSale) {
        itemPriceHtml += Utils.formatMoney(data.price_min) + '<u>('+(data.percent_sale_min) + '%)</u>';
      }else {
        itemPriceHtml += Utils.formatMoney(data.price_min);
      }
    }
//     if (onSale && boostPFSConfig.custom.product_save_amount) {
//       var savePrice = '';
//       if (boostPFSConfig.custom.product_save_type == 'dollar') {
//         savePrice = Utils.formatMoney(data.compare_at_price_min - data.price_min);
//       } else {
//         savePrice = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min);
//         savePrice += '%';
//       }
//       var savePriceText = boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice);;
//       itemPriceHtml += '<span class="grid-product__price--savings">' + savePriceText + '</span>';
//     }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add label
    var customLabel = '';
    var onNew = false;
    var jibbitzCharms = false;
    var newColor = false;
    var online_only = false;
    var onC_C = false;
    data.tags.forEach(function(tag) {
      if (tag.startsWith('_label_')) {
        if (!customLabel) {
          customLabel = tag.replace('_label_', '');
        }
      }
      if (tag.includes('News') || tag.includes('news') || tag.includes('new') || tag.includes('New')) {
        onNew = true;
      }

      if (tag.includes('Jibbitz™ Charms')) {
        jibbitzCharms = true;
      }

      if (tag.includes('Màu') || tag.includes('màu')) {
        newColor = true;
      }
      if (tag.includes('Online Only')) {
        online_only = true;
      }
      if (tag.includes('C&C')) {
        onC_C = true;
      }
    });
        var checkProductItems = '';
    var checkImageScale = '';
    if (jibbitzCharms) {
      checkProductItems = 'jibbitz-charms';
    } else {
      checkImageScale = "image-scale"
    }
    itemHtml = itemHtml.replace(/{{checkProductItem}}/g, checkProductItems);
     itemHtml = itemHtml.replace(/{{checkImageScale}}/g, checkImageScale);

        var productVariantsId = data.variants[0].id;

    itemHtml = itemHtml.replace(/{{productVariantsId}}/g, productVariantsId);
    
    var itemLabelHtml = '';
    if (customLabel) {
      
       if (newColor) {
      itemLabelHtml = '<div class="grid-product__tag grid-product__tag--new-color">' + customLabel + '</div>';
    } else if (online_only) {
         itemLabelHtml = '<div class="grid-product__tag grid-product__tag--online-only">' + customLabel + '</div>';
    } 
       else {
         itemLabelHtml = '<div class="grid-product__tag grid-product__tag--custom">' + customLabel + '</div>';
    }
    } else if (onNew){
      itemLabelHtml = '<div class="grid-product__tag grid-product__tag--new">' + boostPFSThemeConfig.label.new + '</div>';
    }  else {

      // soldOut Label
      if (soldOut) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sold-out">' + boostPFSConfig.label.sold_out + '</div>';
      } else if (onSale) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sale">' + boostPFSConfig.label.sale + '</div>';
      }
    }
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Store Availability
    var itemStoreAvailabilityHtml = onC_C ? '<div class="cc-product__tag cc-product__tag--store_availability">Click&Collect</div>' : '';
    itemHtml = itemHtml.replace(/{{itemStoreAvailability}}/g, itemStoreAvailabilityHtml);

    // Add Quick shop
    var itemQuickShopClass = '';
    var itemQuickShopButtonHtml = '';
    if (boostPFSConfig.custom.quick_shop_enable && !soldOut) {
      itemQuickShopClass = 'grid-product__has-quick-shop';
      itemQuickShopButtonHtml = '<div class="quick-product__btn js-modal-open-quick-modal-{{itemId}} small--hide ' + (isFirstLoad ? '' : 'bc-hide') + '" data-product-id="{{itemId}}">' +
        '<span class="quick-product__label">' + boostPFSConfig.label.quick_shop + '</span>' +
        '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
    itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);

    // Add Reviews
    // if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
    //   var reviewHtml = '';
    //   if(boostPFSConfig.custom.enable_product_reviews) {
    //     reviewHtml = '<span class="shopify-product-reviews-badge" data-id="'+ data.id +'"></span>';
    //   }
    //   itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewHtml);
    // }

 // add Egg review
			var reviewHtml = '<span class="egg-product-reviews-rating" data-id="{{itemId}}" id="{{itemId}}"></span>';
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewHtml);

    // Color swatch
    
      var swatchHtml = buildSwatch(data, this);
      itemHtml = itemHtml.replace(/{{itemSwatch}}/g, swatchHtml.itemSwatch);
      itemHtml = itemHtml.replace(/{{itemSwatchHoverImages}}/g, swatchHtml.itemSwatchHoverImages);



    var itemQuickShopModal = '';

    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable) {
      itemQuickShopModal = '<div id="QuickShopModal-{{itemId}}" class="modal modal--square modal--quick-shop" data-product-id="{{itemId}}">' +
        '<div class="modal__inner">' +
          '<div class="modal__centered">' +
            '<div class="modal__centered-content">' +
              '<div id="QuickShopHolder-{{itemHandle}}"></div>' +
            '</div>' +

            '<button type="button" class="modal__close js-modal-close text-link">' +
              '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg>' +
              '<span class="icon__fallback-text">Close Modal</span>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopModal}}/g, itemQuickShopModal);

	var promotionBlock = '';
	var promotionTitle = Utils.getProductMetafield(data, 'my_fields', 'promotion_title');
    var promotionTitle_1 = Utils.getProductMetafield(data, 'my_fields', 'promotion_title_1');
	var promotionContent = Utils.getProductMetafield(data, 'my_fields', 'promotion_content');
    var promotionId = Utils.getProductMetafield(data, 'custom', 'promotion_id');

    if (promotionTitle && promotionContent) {
      promotionBlock = '<div class="cx-productcard-promo-with-tooltip promo-bg-'+promotionId+ '" style="margin-bottom: 0px;">'  
          + '<div class="tooltip_p" style="color:#d70000;">' + promotionTitle
          + '<span class="tooltiptext_p">'+promotionContent+'</span></div></div>'

    }else{
        promotionBlock = '<div class="cx-productcard-promo-with-tooltip" style="flex-basis: 34px; margin-bottom: 0px;"></div>'
    }

    itemHtml = itemHtml.replace(/{{promotionBlock}}/g, promotionBlock);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemVariantId}}/g, data.variants[0].id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

    return itemHtml;
  };

  // Build Swatch
  function buildSwatch(data, _this) {
    var itemSwatchHtml = '';
    var itemSwatchHoverImagesHtml = '';
    if (boostPFSConfig.custom.collection_color_swatches) {
      var swatchItems = [];
      var swatchHoverImages = [];
      data.options_with_values.forEach(function(option, index) {
        var option_name = option.name.toLowerCase();
        if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1) {
          var option_index = index;
          var values = [];
          data.variants.forEach(function(variant) {
            var value = variant.merged_options[option_index].split(':')[1];
            if (values.indexOf(value) == -1) {
              values.push(value);
              var colorValueSlugify = Utils.slugify(value);
              var colorImage = Utils.optimizeImage(boostPFSAppConfig.general.asset_url.replace('boost-pfs.js', colorValueSlugify + '.png'), '50x');
              var variantImage = Utils.optimizeImage(variant.image, '400x');

              var swatchItem = '<a href="{{itemUrl}}?variant={{variantId}}" ' +
                'class="color-swatch color-swatch--small color-swatch--{{colorValueSlugify}} {{swatchClass}}" ' +
                'data-variant-id="{{variantId}}" ' +
                'data-variant-image="{{variantImage}}" ' +
                'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};"> ' +
                '</a>';

              swatchItem = swatchItem.replace(/{{variantId}}/g, variant.id);
              swatchItem = swatchItem.replace(/{{colorValueSlugify}}/g, colorValueSlugify);
              swatchItem = swatchItem.replace(/{{swatchClass}}/g, variant.image ? 'color-swatch--with-image' : '');
              swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
              swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);
              swatchItem = swatchItem.replace(/{{backgroundColor}}/g, colorValueSlugify.split('-').pop());

              var swatchHoverImage = '<div class="grid-product__color-image grid-product__color-image--' + variant.id + ' small--hide"></div>';

              swatchItems.push(swatchItem);
              swatchHoverImages.push(swatchHoverImage);
            }
          });
        }
      });
      if (swatchItems.length > 1) {
        itemSwatchHtml = ' <div class="grid-product__colors grid-product__colors--{{itemId}}" >' + swatchItems.join('') + '</div>';
        itemSwatchHoverImagesHtml = swatchHoverImages.join('');
      }
    }

    return {
      itemSwatch: itemSwatchHtml,
      itemSwatchHoverImages: itemSwatchHoverImagesHtml
    };
  }

  /************************** END BUILD PRODUCT LIST **************************/

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {



    if (!totalProduct) totalProduct = this.totalProduct;
    var paginationHtml = '';
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {

      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
    return '';
  };

  /************************** BUILD TOOLBAR **************************/

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      //sortingItemsHtml += Shopify.locale === 'vi' ? '<option value="manual" selected disabled hidden>Sắp Xếp Theo</option>' : '<option value="manual" selected disabled hidden>Sort By</option>';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
    }
    return html;
  };

  /* buildExtraProductList */
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;

    // Hover color swatch
    onColorSwatchHover();
       let box = document.querySelector('body');
        let width = box.clientWidth;
        if (width > 768) {
    onColorSwatchHoverCustom();
        }else{
    onColorSwatchHoverCustomMobile();
        }

     // Add swatches
    // this.buildExtrasProductListByAjax(data, 'boost-pfs-integration', function(results) {
    //   results.forEach(function(result) {
    //     var element = jQ('div[data-product-id="'+ result.id +'"] .grid-product__meta');
    //     // console.log(result.swatches);
    //     element.append(result.swatches);
    //   });
    // });

    /* Starts Boost 205442  grid-product__meta*/

    var hasShopifyRoutes =
      Shopify && Shopify.routes && typeof Shopify.routes.root != "undefined";
    var localeURLPart = "";

    if (hasShopifyRoutes) {
      localeURLPart = Shopify.routes.root.replace(/\/$/, "");
    }

    for (var i = 0; i < data.length; i++) {
      const prodId = data[i]["id"];
      quickUrl =
        localeURLPart +
        "/products/" +
        data[i].handle +
        "?view=boost-pfs-integration";
      jQ.ajax({
        url: quickUrl,
        success: function (result) {
          try {
            var res = JSON.parse(result);
            var element = "";
            console.log("res.swatches");
            element = jQ('[data-product-id="' + prodId + '"] .grid-product__meta');
            if (element.find(".product-swatches").length == 0) {
              element.append(res.swatches);
            }
          } catch (error) {
            console.log(123123123,error);
          }
        },
      });
    }

    /* Ends Boost 205442 */
  };

  function onColorSwatchHover() {
    document.querySelectorAll('.color-swatch--with-image').forEach(swatch => {
      swatch.addEventListener('mouseenter', function() {
        var id = swatch.dataset.variantId;
        var image = swatch.dataset.variantImage;
        var el = document.querySelector('.grid-product__color-image--' + id);
        el.style.backgroundImage = 'url(' + image + ')';
        el.classList.add('is-active');
      });
      swatch.addEventListener('mouseleave', function() {
        var id = swatch.dataset.variantId;
        document.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
      });
    });
  }

   function onColorSwatchHoverCustom() {
      setInterval(function(){
        const colorSwatchs = document.querySelectorAll('.cx-swatchColor');
        colorSwatchs.forEach(async (colorSwatch) => {
          colorSwatch.addEventListener('mouseenter', function() {
              const imgUrl = colorSwatch.getAttribute('data-imgurl').replace('//','https://');
              colorSwatch.closest('.grid-product__content').querySelector('.grid-product__image-mask .image-wrap img').setAttribute('src', imgUrl);
              colorSwatch.closest('.grid-product__content').querySelector('.grid-product__image-mask .image-wrap img').setAttribute('srcset', imgUrl);

          });
           colorSwatch.addEventListener('mouseleave', function() {
              const imgUrl = colorSwatch.closest('.grid-product__content').querySelector('.grid-product__image-mask .image-wrap').getAttribute('data-main');
              colorSwatch.closest('.grid-product__content').querySelector('.grid-product__image-mask .image-wrap img').setAttribute('src', imgUrl);
              colorSwatch.closest('.grid-product__content').querySelector('.grid-product__image-mask .image-wrap img').setAttribute('srcset', imgUrl);

          })
        });

        if(colorSwatchs){
             clearInterval(setInterval);
        }

     }, 3000);

   }
  function onColorSwatchHoverCustomMobile() {
      setInterval(function(){
        const colorSwatchs = document.querySelectorAll('.cx-swatchColor');
        colorSwatchs.forEach(async (colorSwatch) => {
          colorSwatch.addEventListener('click', function(event) {
              event.preventDefault();
              const imgUrl = colorSwatch.getAttribute('data-imgurl').replace('//','https://');
              const link = colorSwatch.getAttribute('href');
              colorSwatch.closest('.grid-product__content').querySelector('a[target="_parent"]').setAttribute('href',link );
              colorSwatch.closest('.grid-product__content').querySelector('.grid-product__image-mask .image-wrap img').setAttribute('src', imgUrl);
              colorSwatch.closest('.grid-product__content').querySelector('.grid-product__image-mask .image-wrap img').setAttribute('srcset', imgUrl);
              colorSwatch.closest('.grid-product__content').classList.add('colorswatch_active');

          });
          document.addEventListener("scroll", (event) => {
               const colorSwatchs_active = document.querySelectorAll('.colorswatch_active');
                colorSwatchs_active.forEach(async (colorSwatch_active) => {
                 const imgUrl = colorSwatch_active.querySelector('.grid-product__image-mask .image-wrap').getAttribute('data-main');
                  colorSwatch_active.querySelector('.grid-product__image-mask .image-wrap img').setAttribute('src', imgUrl);
                  colorSwatch_active.querySelector('.grid-product__image-mask .image-wrap img').setAttribute('srcset', imgUrl);

                const mainLink = colorSwatch_active.querySelector('.grid-product__image-mask .image-wrap').getAttribute('data-link');
                  colorSwatch_active.closest('.grid-product__content').querySelector('a[target="_parent"]').setAttribute('href',mainLink );
                colorSwatch_active.classList.remove('colorswatch_active');
              })
          });
          /*
           colorSwatch.addEventListener('mouseleave', function() {
              const imgUrl = colorSwatch.closest('.grid-product__content').querySelector('.grid-product__image-mask .image-wrap').getAttribute('data-main');
              colorSwatch.closest('.grid-product__content').querySelector('.grid-product__image-mask .image-wrap img').setAttribute('src', imgUrl);
              colorSwatch.closest('.grid-product__content').querySelector('.grid-product__image-mask .image-wrap img').setAttribute('srcset', imgUrl);

          })
          */
        });

        if(colorSwatchs){
             clearInterval(setInterval);
        }

     }, 3000);

   }

  /* buildAdditionalElements */
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;

    // Call theme init function
    //wrap all javascript use theme in window.ready event to make sure theme init and register sections successfully
    jQ(document).ready(function() {
      if (typeof theme !== null && window.theme) {
        if(typeof AOS != 'undefined' && typeof AOS.refreshHard == 'function'){
          AOS.refreshHard();
        }
        // Setup page transition classes
        if (typeof theme.pageTransitions == 'function') {
          theme.pageTransitions();
        }

        // Quickview button: Use boost otp & otp style 3, disable add to cart

        // // Reload products inside each quick shop
        // if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
        if (window.$ && typeof $ == 'function') {
          $(window).off('popstate');
        }
      }

      if (isFirstLoad) {
        isFirstLoad = false;
      }

      jQ('.js-drawer-open-collection-filters').on('click', function() {
        jQ('.' + Class.filterOption).each(function() {
          var showMoreType = jQ(this).data('show-more-type');
          if (showMoreType && jQ(this).data('display-type') != 'range') {
            self.buildFilterShowMore(jQ(this).find('.' + Class.filterBlockContent), showMoreType);
          }
        });
      });
    });
    // Add modal container for quickview
    var isReinitQuickview = !isFirstLoad || Utils.isSearchPage() || Globals.queryParams.hasOwnProperty('_');
    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable && isReinitQuickview) {
      jQ('.boost-pfs-quick-shop-modal-container').html('');
      if (data.products.length > 0) {
        data.products.forEach(function(product){
          var quickUrl = Utils.buildProductItemUrl(product) + '?view=boost-pfs-quickview';
          jQ.ajax({url: quickUrl, success: function(result) {
            numberQuickViewModalLoaded++;
            jQ('.boost-pfs-quick-shop-modal-container').append(result);
            if (numberQuickViewModalLoaded == data.products.length) {
              theme.collapsibles.init();
              numberQuickViewModalLoaded = 0;
              jQ('.quick-product__btn').removeClass('bc-hide');
            }
          }});
        });
      }
    }

    // Build total products text
    var totalProductText = '';
    if (data.total_product == 1) {
      totalProductText = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
    } else {
      totalProductText = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
    }
    jQ('.boost-pfs-filter-total-product').html(totalProductText);

    // Build filter button text on mobile
    var numSelectedFilter = jQ('.boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label').length;
    if (numSelectedFilter) {
      jQ('.js-drawer-open-collection-filters').addClass('btn--tertiary-active');
      jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter + ' (' + numSelectedFilter + ')');
    } else {
      jQ('.js-drawer-open-collection-filters').removeClass('btn--tertiary-active');
      jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter);
    }


    setTimeout(() => {
            theme.initQuickShop()
               }, 5000);


    jQ('.view-all').off('click').on('click', function(e) {
      e.preventDefault();
      jQ(this).hide();
      jQ('.view-36').show();
      jQ('.boost-pfs-filter-load-more').addClass('infinite')
//       jQ('.boost-pfs-filter-load-more-button').trigger('click');
      sessionStorage.setItem('boostPFSPreviousPageEvent',null);
      var totalPage = Math.ceil(data.total_product / Globals.queryParams.limit);
      var currentPage = Globals.queryParams.page + 1;
      for (var i = currentPage; i <= totalPage; i++) {
        FilterApi.setParam('page', i);
        FilterApi.applyFilter('page');
      }
    })

    jQ('.view-36').off('click').on('click', function(e) {
      e.preventDefault();
      jQ('.view-36').hide();
      jQ('.view-all').show();
      jQ('.boost-pfs-filter-load-more').removeClass('infinite');
      jQ(Selector.products).html('');
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('page');
      window.scrollTo({
        top: jQ(Selector.products).offset().top - 50,
        behavior: 'smooth'
      });
    })

     let box = document.querySelector('body');
        let width = box.clientWidth;
    

      const queryString = window.location.search;
    console.log(queryString)
    const urlParams = new URLSearchParams(queryString);
    const sort = urlParams.get('sort')
    if(sort != null){
       document.querySelector(".boost-pfs-sort-title").classList.add("boost-pfs-sort-title-hide");
      document.querySelector(".boost-pfs-filter-top-sorting-select").classList.add("boost-pfs-filter-top-sorting-hide");
    }
    
    
    
  };

  FilterOptionItem.prototype.afterRender = function () {
    this.$element.find('.boost-pfs-filter-option-value').addClass(Utils.slugify(this.label));
  }

  ProductPaginationLoadMore.prototype.afterRender = function () {
    if (this.$element.find('.view-all').length < 1) {
      var html = '<a class="view-all text-link view-options-text" rel="nofollow" href="javascript:void(0)" data-page="View all">Xem tất cả</a>';
      this.$element.append(html)
    }
  }
    PageInfoSearch.prototype._buildSEOTitle = function () {
  if (this.searchTerm && this.searchTerm !== '') {
			var enableFixHeadTitle = Settings.getSettingValue('search.enableFixHeadTitle');
			var seoTitle = this.compileSEOTitleTemplate();
			if (enableFixHeadTitle && seoTitle) {
				document.title = seoTitle.replace(/&quot;/g,'"');
			} else {
				document.title = document.title.replace(/[0-9]+/,this.data.total_product);

			}
		}
  }


  PageList.prototype.render = function() {
      // Get all collection item
      this.$element.html('');
      this.pageItems.forEach((pageItem) => {
          this.$element.append(pageItem.$element);
      });
      // Boost SSS
      async function customFunction(data) {
        const callAjaxArr = data.map(async (pageItem) => {
          await handleAjax(pageItem);
          return pageItem;
        });
        Promise.all(callAjaxArr).then((values) => {
          // handleSwatchEvents();
        });
      }

      if (Shopify.locale == 'en') {
        customFunction(this.pageItems);
      }
      // END Boost SSS
  }

  async function handleAjax(pageItem) {
    try {
        let linkAjax = "/en" + pageItem.data.url + "?view=boost-pfs-translation";
        let requestReg = await formRequest(linkAjax);
        let parse_res_success = JSON.parse(requestReg);
        // content
        let content = parse_res_success.content;
        let parser = new DOMParser();
        let doc = await parser.parseFromString(parse_res_success.content, 'text/html');
        let textContent = doc.body.textContent.trim() || '';
        if (textContent.length > 320) {
            textContent = textContent.substr(0, 320) + '...';
        }
        jQ(pageItem.$element[0]).find('.boost-pfs-search-result-list-item-title').html(parse_res_success.title);
        jQ(pageItem.$element[0]).find('.boost-pfs-search-result-list-item-description').html(textContent);
    } catch (error) {
      console.log(error);
    }
  }
  function formRequest(value) {
    return new Promise((resolve, reject) => {
      var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
      xhr.open("GET", value);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.onload = () => resolve(xhr.responseText);
      xhr.onerror = () => reject(xhr.statusText);
      xhr.send();
    });
  }



})();

FilterResult.prototype.afterRender = function() {
  if(typeof aio_pr_review_data_load === 'function') {
    if($('.egg-product-reviews-rating').children('div').length==0){
      $('.egg-product-reviews-rating').html('');
      aio_pr_review_data_load();
      var ratingContainer = $('.egg-product-reviews-rating').children();
      if('undefined' !== typeof ratingContainer[1]) {
        ratingContainer[1].remove();
      }
    }
  }
}


